const HeartFilled = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.2251 4.40614L11.4428 5.10868C8.45328 1.14758 4.23309 1.85011 3.21167 5.36279C2.09559 9.19435 6.49515 17.3607 8.75223 17.8988C11.0093 18.4369 18.9913 12.2436 19.1258 6.79277C19.2604 1.34189 13.9241 3.20536 12.2251 4.40614Z"
                fill="#686058"
            />
            <path
                d="M20.0772 4.74999C19.4046 2.9513 17.1475 2.08933 15.2392 2.45305C13.7181 2.81538 12.3214 3.57739 11.1934 4.66031C10.9586 3.99696 10.5964 3.38592 10.1271 2.86162C8.29357 0.818785 4.79584 0.290637 2.74802 2.11922C0.700205 3.94781 0.755013 6.99711 1.38779 9.593C2.16008 12.6174 6.20589 19 8.21883 19C10.2318 19 17.9447 12.7818 19.6288 8.77089C20.1619 7.48041 20.5555 6.04047 20.0772 4.74999Z"
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default HeartFilled
